import { BorderGridContainer, GridBox, H4 } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import styled from 'styled-components';

import Banner from '../../../elements/banner';
import constants from '../../../ahm-constants';
import CONTENT from './content';
import Head from '../../../../utils/head';
import InsuranceSection from '../components/section';
import isFeatureEnabled from '../../../utils/is-feature-enabled';
import LifeInsuranceNav from '../components/nav';
import RedirectAdapter from '../../../utils/redirect-adapter';

type LifeInsuranceHelpAndSupportProps = {
  insuranceType: string;
};

const StyledInsuranceSection = styled(InsuranceSection)`
  padding-bottom: 8rem;
`;

const LifeInsuranceHelpAndSupportPage = ({ insuranceType }: LifeInsuranceHelpAndSupportProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ 'income-protection': { meta: { title: string; description: string; }; banner: { title: string; preHeading: string; }; nav: { name: string; url: string; }[]; alert: Element; body: Element; thingsYouShouldKnow: Element; }; life: { ...; }; }'.
  const content = CONTENT?.[insuranceType];

  if (isEmpty(content)) {
    return <RedirectAdapter to={constants.URLS.SALES.ERROR_404} />;
  }

  const meta = content?.meta;

  return (
    <>
      <Head titleTemplate="%s - ahm life insurance">
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Head>
      <BorderGridContainer hideBorderTop>
        <Banner {...content.banner} />
        <GridBox padding="0">
          {isFeatureEnabled('swissreNotification') && content.alert}
          <StyledInsuranceSection sidebar={<LifeInsuranceNav items={content.nav} />}>
            {content.body}
          </StyledInsuranceSection>
          <StyledInsuranceSection theme="grey10" id="terms">
            <H4 variant="marginBottomSpacer9">Things you should know</H4>
            {content.thingsYouShouldKnow}
          </StyledInsuranceSection>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default LifeInsuranceHelpAndSupportPage;
